exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex[data-v-2fc04664]{display:flex}.text-area-lang-info[data-v-2fc04664]{width:18%}", ""]);

// exports
